import React from 'react';
import PropTypes from 'prop-types';
import {Button, Container, Grid, Header, List} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {injectIntl, intlShape} from 'react-intl';
import {SiteNameKeys} from 'utils/DBUtils';
import Config from 'Config';

const BreakSummary = (props) => (
    <Grid columns={2} className="animResponse fadeInDown db-break-summary">
        <Grid.Column width={9}>
            <Header as='h1' style={{margin: "0"}}> {props.header} </Header>
            <List>
                <List.Item>{props.breakType}: {props.title}</List.Item>
                <List.Item> <a target="_blank" href={`${Config.WEBSITE_URL}preview/?permalink=${props.header}`}>Preview</a> / <a target="_blank" href={`${Config.WEBSITE_API_URL}legacy/break/${props.header}`}>JSON</a></List.Item>
                {/* <List.Item><b>{props.intl.formatMessage({id: 'type'}) + ":"}</b> {props.breakType}</List.Item> */}
                <List.Item className="site-name">
                  <b>{props.intl.formatMessage({id: 'site'}) + ":"}</b> {props.intl.formatMessage({id: SiteNameKeys[props.site]})} <a onClick={props.showCopyBreakModal}>Copy break</a>
                </List.Item>
                <List.Item><b>{props.intl.formatMessage({id: 'totalPossiblePoints'}) + ":"}</b> {props.points}
                </List.Item>
                <List.Item><a target="_blank" href={`${Config.BEAKER2_URL}#/break?displayedFilters=%7B%7D&filter=%7B"q"%3A"${props.permalink}"%7D&order=DESC&page=1&perPage=25&sort=startDate`}>beaker2</a> <i className="fa-solid fa-up-right-from-square"></i>
                </List.Item>
{/* 
                <List.Item><b>{props.intl.formatMessage({id: 'featured'}) + ":"}</b> <Link
                    to="/tools/featured-manager">{props.featured}</Link></List.Item>
                {props.userCanViewAnalytics && (
                  <List.Item><Link to={'/break/' + props.challengeId + '/analytics'}>{props.intl.formatMessage({id: 'analytics'})}</Link></List.Item>
                )} 
*/}

            </List>
        </Grid.Column>

        <Grid.Column width={7} className="db-break-control">
            <Container>
              <Grid.Row>
                <a href={Config.ENV_PREVIEW_SITE_PREFIX[props.lang ? props.lang : 'en-US'] + 'break/' + props.permalink} target="_blank">
                  <Button>Preview (legacy)</Button>
                </a>
                {props.showMasterLink && <Link to={'/break/' + props.challengeId + '/edit'}><Button>Back to Edit</Button></Link>}

                {/* NB: one, but only one, of showViewAllLink and showUnpublishLink should be true. */}
                {props.showViewAllLink ? (
                    <Link to={'/break/' + props.challengeId + '/all'}><Button>View all platforms</Button></Link>
                ) : (props.showUnpublishLink && props.userCanUnpublish) ? (
                    <Button disabled={!props.canUnpublishEditorial} onClick={props.unpublishChallenge}>{props.intl.formatMessage({id: 'buttons.unpublish'})}</Button>
                ) : null}
              </Grid.Row>
              <Grid.Row>
                <Button className="grey-button" onClick={props.validateChallenge}>
                  {props.intl.formatMessage({id: props.breakType === "editorial" ? 'buttons.validate' : 'buttons.validateAll'})}
                </Button>
                {props.userCanPublish && (
                    <Button className="grey-button" loading={props.challengeIsPublishing} onClick={props.publishChallenge}>
                      {props.intl.formatMessage({id: props.breakType === "editorial" ? 'buttons.publishNow' : 'buttons.publishAll'})}
                    </Button>
                )}
              </Grid.Row>
            </Container>
        </Grid.Column>
    </Grid>
);

BreakSummary.propTypes = {
    intl: intlShape,
    header: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    challengeId: PropTypes.string.isRequired,
    permalink: PropTypes.string.isRequired,
    breakType: PropTypes.string.isRequired,
    site: PropTypes.string.isRequired,
    lang: PropTypes.string,
    onClick: PropTypes.func,
    points: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
    featured: PropTypes.string.isRequired,
    isLoaded: PropTypes.bool,
    userCanViewAnalytics: PropTypes.bool.isRequired,
    userCanPublish: PropTypes.bool.isRequired,
    userCanUnpublish: PropTypes.bool.isRequired,
    showCopyBreakModal: PropTypes.func.isRequired,
    challengePublishStatus: PropTypes.string.isRequired,
    validateChallenge: PropTypes.func.isRequired,
    publishChallenge: PropTypes.func,
    canUnpublishEditorial: PropTypes.bool,
    unpublishChallenge: PropTypes.func,
    showMasterLink: PropTypes.bool,
    showViewAllLink: PropTypes.bool,
    showUnpublishLink: PropTypes.bool
};

export default injectIntl(BreakSummary);



// WEBPACK FOOTER //
// ./public/components/common/BreakSummary.jsx